module.exports = __webpack_public_path__ + "media/internal-chat-notification.86b47c1e.mp3";